import { getAnswersByUserId, getSurveyCompletedByUserIdAndSurveyType } from "@/utils/apis/emr-service";
import { SurveyType } from "@/utils/enums/Surveys";
import { useAuthStore } from "@/utils/stores/useAuthStore";
import { useSurveyDataStore } from "@/utils/stores/useSurveyDataStore";
import { useCallback, useState } from "react";

export const useSurveyData = () => {
    const { auth } = useAuthStore();
    const { updateSurveyData } = useSurveyDataStore();
    const [isLoading, setIsLoading] = useState(false);

    const fetchSurveyData = useCallback(async () => {
        const { idToken, userId } = auth;
        if (!idToken || !userId) return;

        try {
            setIsLoading(true);

            const [surveyData, allAnswers] = await Promise.all([
                getSurveyCompletedByUserIdAndSurveyType(userId, idToken, SurveyType.HealthAssessment),
                getAnswersByUserId(userId, idToken),
            ]);

            if (surveyData) {
                updateSurveyData({
                    healthAssessmentAnswers: surveyData[0].data.map(answer => ({
                        id: answer.question_id,
                        answers: answer.value,
                    })),
                    healthAssessmentCompleted: true,
                });
            } else {
                updateSurveyData({ healthAssessmentCompleted: false });
            }

            if (allAnswers) {
                updateSurveyData({ allAnswers });
            }

        } catch (error) {
            console.error("Error fetching survey data:", error);
        } finally {
            setIsLoading(false);
        }
    }, [auth, updateSurveyData]);

    return {
        fetchSurveyData,
        isLoading,
    };
}